import { gql } from "@apollo/client";

const BULK_ACCOUNT = gql`
  mutation bulkAccount($input: BulkAction!) {
    bulkAccount(input: $input) {
      status
      data
      error
    }
  }
`;
export default BULK_ACCOUNT;
